<script setup lang="ts">
import { faPipe } from "@fortawesome/pro-light-svg-icons";
import type { Menu } from "~/components/mail/EditorMenu.vue";
import type { FieldDefinition } from "~/models/Automation";

defineProps<{
  fields: FieldDefinition[]
  editor: any,
  menu: Menu
}>()

const emit = defineEmits(['action']);

const action = (action: () => void) => {
  action();
  emit('action');
}
</script>

<template>
  <div class="bg-white flex gap-1 shadow-sm rounded-md p-1 items-center">
    <template v-for="(group, index) in menu">
      <FontAwesomeIcon v-if="index > 0" :icon="faPipe" class="opacity-50" />
      <template v-for="item in group">
        <UPopover v-if="item.menu && item.menu.length" :popper="{ placement: 'top' }">
          <template #panel>
            <EditorMenuGroups :fields="fields" :editor="editor" :menu="item.menu" @action="emit('action')" />
          </template>
          <MailEditorMenuButton :item="item" />
        </UPopover>
        <MailEditorMenuButton v-else-if="item.action" :item="item" @click.prevent.stop="action(item.action)" />
        <component v-else-if="item.component" :is="item.component" :item="item" :editor="editor" :fields="fields"
          @action="emit('action')" />
        <pre v-else>{{ item }}</pre>
      </template>
    </template>
  </div>
</template>

<style scoped></style>